import { GridColumn } from '../../../../../../generic/grid-table'
import { IWarehouseLocation } from '../../../../../../modules/API/Warehouse/models/locations'
import { lightTheme } from '../../../../../../../styles/theme'
import { resolveLocationTypeLabel } from '../../../../../../generic/artcoded/locationType'

const ACTIVE_BADGE_COLOR = lightTheme.colors.success
const INACTIVE_BADGE_COLOR = lightTheme.colors.danger

export const buildLocationControlColumns = (
  resolveWarehouseLabel: (value: unknown) => string,
  resolveRoomLabel: (value: unknown) => string,
): GridColumn<IWarehouseLocation>[] => [
  { key: 'CodeLocation', title: 'איתור', dataType: 'string', sortable: true },
  {
    key: 'WarehouseID',
    title: 'מחסן',
    dataType: 'number',
    sortable: true,
    cellRendererType: 'text',
    labelResolver: resolveWarehouseLabel,
  },
  {
    key: 'Room',
    title: 'חדר',
    dataType: 'number',
    sortable: true,
    cellRendererType: 'text',
    labelResolver: resolveRoomLabel,
  },
  { key: 'Line', title: 'שורה', dataType: 'string', sortable: true },
  {
    key: 'LocationType',
    title: 'סוג',
    dataType: 'number',
    sortable: true,
    cellRendererType: 'text',
    labelResolver: resolveLocationTypeLabel,
  },
  {
    key: 'Active',
    title: 'סטטוס',
    dataType: 'boolean',
    sortable: true,
    cellRendererType: 'badge',
    badgeResolver: (row) =>
      row.Active
        ? { label: 'פעיל', color: ACTIVE_BADGE_COLOR }
        : { label: 'לא פעיל', color: INACTIVE_BADGE_COLOR },
  },
]
